export default __webpack_public_path__ + "static/media/d2.61ed4036.jpg";